export function findSalaryEntry(trainerId, category, salaryDict) {
  let salaryEntry = (salaryDict || []).find(entry => entry.trainer?.yc_id === trainerId)

  if (!salaryEntry && category) {
    salaryEntry = (salaryDict || []).find(
      entry => entry.trainer === null && entry.category === category,
    )
  }

  return salaryEntry || null
}

export function getTrainingDurationHours(record) {
  if (record?.start && record?.end) {
    const start = new Date(record.start)
    const end = new Date(record.end)
    const diffMs = end - start

    if (diffMs > 0) {
      return diffMs / (1000 * 60 * 60)
    }
  }

  return 1
}

export function formatTrainingDuration(record) {
  const hours = getTrainingDurationHours(record)
  const totalMinutes = Math.round(hours * 60)
  const wholeHours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60

  if (wholeHours > 0 && minutes > 0) {
    return `${wholeHours} ч ${minutes} мин`
  }

  if (wholeHours > 0) {
    return `${wholeHours} ч`
  }

  return `${minutes} мин`
}

export function calcRecordSalary(record, salaryEntry) {
  const hours = getTrainingDurationHours(record)
  const pricePerHour = salaryEntry?.price || 0
  const splitHourPrice = salaryEntry?.split_hour_price || 0

  let amount = pricePerHour * hours

  if (record?.split === true) {
    amount += splitHourPrice * hours
  }

  return Math.round(amount)
}

export function calcTrainerSalary(trainer, salaryEntry) {
  const records = (trainer.records || []).map(record => ({
    ...record,
    duration_hours: getTrainingDurationHours(record),
    salary: calcRecordSalary(record, salaryEntry),
  }))

  const totalSalary = records.reduce((sum, record) => sum + record.salary, 0)

  return {
    records,
    totalSalary,
  }
}
